import React from 'react';
import ReactDOM from 'react-dom';
import './index.scss';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { Provider } from 'react-redux';
import storeCreator from '../src/redux/store';


const store = storeCreator();

const axios = require('axios');
window.baseURL = 'https://apirevista.farmaciasdelpueblo.com.ar/'; // 'https://apirevista.farmaciasdelpueblo.com.ar/';
axios.defaults.baseURL = window.baseURL;
axios.defaults.headers.common['Accept'] = 'application/json';
axios.defaults.headers.common['Content-Type'] = 'application/json';


ReactDOM.render(

    <Provider store={store}>
      <App />
    </Provider>,
  document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
